module.exports = __webpack_public_path__ + "img/snorkeling-16.e0705413.png";